import React, { Component } from "react";
import { Row, Col, Button, Container , InputGroup} from "reactstrap";
import { inject, observer } from "mobx-react";
import FiltrosCargaGeralAcompanhamentoStore from "../stores/FiltrosCargaGeralAcompanhamentoStore";
import {
  FecharFiltro,
  Filtro,
  IconeCarregar,
} from "../../comum/components/Icones";
import Card from "../../comum/components/Card";
import InputFiltro from "../../comum/components/InputFiltro";
import FormSelectSimples from "../../comum/components/FormSelectSimples";
import FormOnlyPositiveNumberSimples from "../../comum/components/FormNumberSimples";
import lscache from "lscache";
import FormDatePicker from "../../comum/components/FormDatePicker";
@inject("store")
@observer
export default class FiltrosCargaGeralAcompanhamento extends Component {
  constructor(props) {
    super(props);

    this.controllerCargaGeral = this.props.controller;
    this.controller = new FiltrosCargaGeralAcompanhamentoStore();

    this.state = { maisFiltros: false, filtrado: false };
  }

  filtros = () => {
    if (!this.state.maisFiltros) {
      return this.filtrosBasicos();
    } else {
      return this.filtrosCompletos();
    }
  };

  handleFiltrar() {
    this.setState((state) => ({ filtrado: true }));
    _.set(
      this.controller.filtros,
      "operacao",
      this.controller.filtroNavio ? this.controller.filtroNavio.value : null
    ); //value é o primeiro label o segundo valor
    this.controllerCargaGeral.listar(this.controller.filtros);
  }

  filtrosBasicos = () => {
    let xl = 2;
    let lg = 4;
    let md = 4;
    return (
      <React.Fragment>
        <FormSelectSimples
          titulo="Navio"
          xl={xl}
          lg={lg}
          md={md}
          sm={12}
          xs={12}
          itens={this.controllerCargaGeral.naviosFiltros}
          dado={this.controller.filtroNavio}
          bloqueado={!this.controllerCargaGeral.naviosFiltros}
          onChange={(event) => this.controller.onChangeFiltroNavios(event)}
        />

        {this.controllerCargaGeral.loadingNavios && (
          <IconeCarregar tamanho="2x" />
        )}
        <InputFiltro
          titulo="Placa"
          xl={xl}
          lg={lg}
          md={md}
          sm={12}
          xs={12}
          value={""}
          onEnter={() => this.handleFiltrar()}
          onChange={(event) => this.controller.onChangeFiltro("placa", event)}
        />

        <Col
          className="col-botoes pl-1"
          xl={xl}
          lg={lg}
          md={md}
          sm={12}
          xs={12}
        >
          <Button
            className="btn-filtros"
            onClick={() => this.mudaFiltros()}
            outline
          >
            <Filtro color="#93A0AD" className="mr-2" width="15" height="15" />
            Mais filtros
          </Button>
          <Button
            className="btn-com-bordas-primary btn-filtrar"
            onClick={() => {
              this.handleFiltrar();
            }}
          >
            Filtrar
          </Button>
        </Col>
      </React.Fragment>
    );
  };

  filtrosCompletos = () => {
    let xl = 2;
    let lg = 4;
    let md = 4;
    return (
      <React.Fragment>
        {/*<Col>*/}
        {/*<Row className={"linhaFiltros"}>*/}
        <FormSelectSimples
          titulo="Navio"
          xl={xl}
          lg={lg}
          md={md}
          sm={12}
          xs={12}
          itens={this.controllerCargaGeral.naviosFiltros}
          dado={this.controller.filtroNavio}
          bloqueado={!this.controllerCargaGeral.naviosFiltros}
          onChange={(event) => this.controller.onChangeFiltroNavios(event)}
        />

        {this.controllerCargaGeral.loadingNavios && (
          <IconeCarregar tamanho="2x" />
        )}
        <InputFiltro
          titulo="Placa"
          xl={xl}
          lg={lg}
          md={md}
          sm={12}
          xs={12}
          value={""}
          onEnter={() => this.handleFiltrar()}
          onChange={(event) => this.controller.onChangeFiltro("placa", event)}
        />

        <FormOnlyPositiveNumberSimples
          titulo="CPF"
          xl={xl}
          lg={lg}
          md={md}
          sm={12}
          xs={12}
          onEnter={() => this.handleFiltrar()}
          onChange={(event) => this.controller.onChangeFiltro("cpf", event)}
        />

        <FormOnlyPositiveNumberSimples
          titulo="CNH"
          xl={xl}
          lg={lg}
          md={md}
          sm={12}
          xs={12}
          onEnter={() => this.handleFiltrar()}
          onChange={(event) => this.controller.onChangeFiltro("cnh", event)}
        />
        <FormDatePicker
          titulo="Data Início"
          xs={12}
          sm={12}
          md={12}
          lg={lg}
          xl={xl}
          date={this.controller.dataInicio}
          onChange={(value) => this.controller.onChangeDataInicio(value)}
          //alerta={}
        />
        <FormDatePicker
          titulo="Data Fim"
          xs={12}
          sm={12}
          md={12}
          lg={lg}
          xl={xl}
          date={this.controller.dataFim}
          onChange={(value) => this.controller.onChangeDataFim(value)}
        />
        <Col className="col-botoes" xl={xl} md={md} sm={12} xs={12}>
          <Button
            className="btn-filtros"
            onClick={() => this.mudaFiltros()}
            outline
          >
            <FecharFiltro
              color="#93A0AD"
              className="mr-2"
              width="15"
              height="15"
            />
            Menos filtros
          </Button>
          <Button
            className="btn-com-bordas-primary btn-filtrar"
            onClick={() => {
              this.handleFiltrar();
            }}
          >
            Filtrar
          </Button>
        </Col>
      </React.Fragment>
    );
  };

  mudaFiltros = () => {
    this.setState({ maisFiltros: !this.state.maisFiltros });
  };

  inserindoNovas = () => {
    return this.controllerCargaGeral.novasCargas.length > 0;
  };

  render() {
    return (
      <div className="filtro-card filtros-cabotagem">
        <Card
          className={`area-form pb-0 ${
            !this.inserindoNovas() ? "" : "escondido"
          }`}
        >
          <Row className="pb-0">{this.filtros()}</Row>
        </Card>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/carga-geral/components/FiltrosCargaGeralAcompanhamento.js